module.exports = __webpack_public_path__ + "img/s6.0c8d0df4.png";